import { httpGet } from '@/api/httpClient';

export type SuperAssociationsDevice = {
  id: number;
  name: string;
  code: string;
  boxId: number;
  type: string | null;
  areaIds: number[];
};

export type SuperAssociationsDevicesResponse = {
  projectId: number;
  count: number;
  devices: SuperAssociationsDevice[];
};

export type SuperAssociationsAreaDevice = {
  id: number;
  name: string;
  code: string;
  boxId: number;
  removed: boolean;
  type: string | null;
};

export type SuperAssociationsAreaDevicesResponse = {
  projectId: number;
  areaId: number;
  count: number;
  devices: SuperAssociationsAreaDevice[];
};

export type SuperAssociationsRoomWithRemovedDevices = {
  id: number;
  name: string;
  code: string;
  removedDevicesCount: number;
};

export type SuperAssociationsRoomsWithRemovedDevicesResponse = {
  projectId: number;
  count: number;
  rooms: SuperAssociationsRoomWithRemovedDevices[];
};

export const superAssociationsApi = {
  getDevices: (projectId: number) =>
    httpGet<SuperAssociationsDevicesResponse>(`/admin/super-associations/projects/${projectId}/devices`),
  getAreaDevices: (projectId: number, areaId: number) =>
    httpGet<SuperAssociationsAreaDevicesResponse>(`/admin/super-associations/projects/${projectId}/areas/${areaId}/devices`),
  getRoomsWithRemovedDevices: (projectId: number) =>
    httpGet<SuperAssociationsRoomsWithRemovedDevicesResponse>(
      `/admin/super-associations/projects/${projectId}/rooms-with-removed-devices`
    ),
};

